var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 33V15M14 33V15M20 20V28C20 28.9319 20 29.3978 20.1522 29.7654C20.3552 30.2554 20.7446 30.6448 21.2346 30.8478C21.6022 31 22.0681 31 23 31C23.9319 31 24.3978 31 24.7654 30.8478C25.2554 30.6448 25.6448 30.2554 25.8478 29.7654C26 29.3978 26 28.9319 26 28V20C26 19.0681 26 18.6022 25.8478 18.2346C25.6448 17.7446 25.2554 17.3552 24.7654 17.1522C24.3978 17 23.9319 17 23 17C22.0681 17 21.6022 17 21.2346 17.1522C20.7446 17.3552 20.3552 17.7446 20.1522 18.2346C20 18.6022 20 19.0681 20 20Z",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsa);
export default __webpack_public_path__ + "static/media/bsa.70d4c7166c3b0af436aaa224d865a12a.svg";
export { ForwardRef as ReactComponent };